import { Component, inject } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { ChatService } from "@app/shared/chat/services/chat.service";

@Component({
  selector: "app-chat-icon",
  imports: [TranslatePipe, RouterLink],
  templateUrl: "./chat-icon.component.html",
  styleUrl: "./chat-icon.component.scss",
})
export class ChatIconComponent {
  chatService = inject(ChatService);
}
